module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var fire = Util.clone(value); 
    ; __append("\n\n")
    ;  if (fire.removed) { 
    ; __append("\n\n<b>УДАЛЁН</b>\n\n")
    ;  } else { 
    ; __append("\n\n")
    ;  if (Util.isDefined(fire.objecttype)) { 
    ; __append("\n<b>")
    ; __append(escapeFn( Glonass.ObjectType.title(fire.objecttype) ))
    ; __append("</b>\n")
    ;  } 
    ; __append("\n\n")
    ;  if (fire.threats && fire.threats.length) { 
    ; __append("\n<b>")
    ; __append(escapeFn( Glonass.FireThreat.titles(fire.threats) ))
    ; __append("</b>\n")
    ;  } 
    ; __append("\n\n")
    ;  if (fire.house) { 
    ; __append("\n<div>\n	")
    ; __append( card.render("House", {value: fire.house, mode: mode}) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n\n")
    ;  if (fire.address) { 
    ; __append("\n")
    ;  if (!Util.Object.senseless(fire.address) || mode == "foreign") { 
    ; __append("\n<div><b>Адрес:</b></div>\n")
    ; __append( card.render("Address", { value: fire.address, mode: mode }) )
    ; __append("\n")
    ;  } 
    ; __append("\n")
    ;  } 
    ; __append("\n\n")
    ;  if (fire.comment) { 
    ; __append("\n<div>\n	")
    ; __append(escapeFn( fire.comment ))
    ; __append("\n</div>\n")
    ;  } else if (mode == "foreign" && native && native.comment) { 
    ; __append("\n<s>комментарий</s>\n")
    ;  } 
    ; __append("\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}